import React from "react";
import Navbar from "../component/Navbar";
import Hero from "../component/Hero";
import Featured from "../component/Featured";
import "../styles/Home.css";
// import AboutGallery from "../component/AboutGallery";
import { Helmet } from "react-helmet-async";
import AboutStory from "../component/AboutStory";
// import RetreatTimeline from "../component/ExperinceSection";
import DestinationGallery from "../component/DestinationGallery";
import ExperienceSection from "../component/ExperinceSection";




function Home() {
  return (
    <>
      <Helmet>
        <title>PlanBanaLo | Adventure Camping & Yoga Retreats</title>
        <meta
          name="description"
          content="Discover premium camping experiences, yoga retreats, and adventure trips across India with PlanBanaLo."
        />
      </Helmet>
      <Navbar />
      <Hero />
  

      <section className="sacred-section">
        <div className="sacred-container">

          <div className="sacred-left">
            <h2>Return to Stillness</h2>
          </div>

          <div className="sacred-right">
            <p>
              In the quiet valleys of the Himalayas,
              we create spaces where breath slows,
              thoughts soften, and the noise of the world fades away.
              <br />
              PlanBanLo is not a vacation.
              It is a gentle return — to your body, your breath, yourself.
            </p>

          </div>

        </div>
      </section>

      {/* <AboutGallery /> */}

      <AboutStory />
      <Featured />
      <ExperienceSection/>
      <DestinationGallery/>



      <section className="cta-section">
        <div className="container">
          <h2>Ready to Escape the Noise?</h2>
          <button className="primary-btn">Start Your Journey</button>
        </div>
      </section>


    </>
  );
}

export default Home;
